import { X } from "@phosphor-icons/react";

export function FilterChip({ label, onRemove }: { label: string; onRemove: () => void }) {
  return (
    <span className="inline-flex items-center gap-1 rounded-md bg-muted px-2 py-0.5 text-[11px] font-medium text-foreground">
      {label}
      <button
        onClick={onRemove}
        className="flex size-3.5 items-center justify-center rounded transition-colors hover:bg-foreground/10"
      >
        <X className="size-2.5" />
      </button>
    </span>
  );
}
